<template>
  <div>
    <v-dialog transition="dialog-bottom-transition" max-width="1000">
      <template v-slot:activator="{ on, attrs }">
        <span class="symbol symbol-35 symbol-light-success">
          <img
            style="object-fit: contain"
            alt=""
            v-bind="attrs"
            v-on="on"
            v-if="url"
            :src="url"
          />
          <span
            v-else
            class="symbol-label font-size-h5 font-weight-bold"
            style="background-color: white"
          >
          </span>
        </span>
      </template>
      <template v-slot:default="dialog">
        <v-card>
          <v-card-text class="pa-4 text-center">
            <img alt="image" class="w-100" :src="url" />
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn color="red" dark @click="dialog.value = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ShowUrlImage",
  props: ["url"],
};
</script>
